import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SpinnerLabelComponent } from './components/spinner-label.component';
import { ProgressSpinnerModule } from '../progress-spinner/progress-spinner.module';

@NgModule({
  declarations: [SpinnerLabelComponent],
  imports: [ProgressSpinnerModule, CommonModule],
  exports: [SpinnerLabelComponent],
})
export class SpinnerLabelModule {}
